import { type Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { CONNECTOR_SOURCE_CHIP_NODE_NAME } from '@atlassian/conversation-assistant-content-renderer/controllers/editor/connector-source-chip-node';
import { ROVO_SKILL_EXTENSION_TYPE } from '@atlassian/conversation-assistant-content-transformer/utils/skills';

export const getActualTextContent = (doc: PMNode): string => {
	let actualTextContent = '';

	doc.descendants((node: PMNode) => {
		if (node.isText) {
			actualTextContent = actualTextContent + node.text;
		} else if (node.type.name === 'mention') {
			let mentionText = node.attrs.text || '@…';
			actualTextContent = actualTextContent + mentionText;
		} else if (node.type.name === 'inlineCard') {
			const url = node.attrs.url || '';
			actualTextContent = actualTextContent + url;
		} else if (
			node.type.name === 'inlineExtension' &&
			node.attrs.extensionType === ROVO_SKILL_EXTENSION_TYPE
		) {
			const skillSlug = node.attrs.parameters?.slug || '';
			actualTextContent = actualTextContent + skillSlug;
		} else if (node.type.name === CONNECTOR_SOURCE_CHIP_NODE_NAME) {
			const display = node.attrs.display ?? '';
			actualTextContent = actualTextContent + display;
		}
		// For other node types, continue traversing but don't count them
		return true;
	});
	return actualTextContent;
};
